import App from '../app'
import Vue from 'vue'
import VContactForm from '../../vue/VContactForm.vue'

/* eslint-disable no-new */
new Vue({
  extends: App,
  components: {
    VContactForm
  },
  methods: {

  }
})
